// Libraries
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 40px;

  ::-webkit-scrollbar {
    width: 0.625rem;
    height: 0.625rem;
  };

  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 3.375rem;
    margin: 0.25rem;
  };

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.color.modalPanel.scrollBackgroundColor};
    border-radius: 3.375rem;
    border: 0.125rem solid transparent;
    background-clip: padding-box;
  };

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  };
`;

export const ParagraphContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
 `;

export const NumericContainer = styled.div`
  background-color: ${({ theme }) => theme.color.ifmStatus.valueBackgroundColor};
  border: 1px solid ${({ theme }) => theme.color.ifmStatus.borderColor};
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  margin-left: 4px;
`;

export const ModuleParagraphContainer = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const HydraulicOilTemp = styled.div`
  padding-top: 26px;
  display: flex;
`;

export const HydraulicReservoirLowLevel = styled.div`
  padding-top: 36px;
  display: flex;
`;

export const ClampPressureContainer = styled.div`
  padding-top: 54px;
`;

export const TrampPressureContainer = styled.div`
  padding-top: 22px;
`;

export const SupplyTempContainer = styled.div`
  padding-top: 22px;
`;

export const LubeContainer = styled.div`
  padding-top: 26px;
  gap: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModuleContainer = styled.div`
  display: flex;
  padding: 0 20px 0 20px;
  flex-direction: column;
  gap: 8px;
  width: max-content;
`;

export const CrusherTextContainer = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const CrusherParagraphContainer = styled.div`
  padding-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
`;

export const TrampPressureParagraph = styled.div`
  padding-top: 24px;
`;

export const ReturnTempContainer = styled.div`
  padding-top: 22px;
`;

export const LubeFlowContainer = styled.div`
  padding-top: 24px;
`;

export const LubeTextsContainer = styled.div`
  padding-top: 24px;
  gap: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CrusherParagraphsContainer = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EccentricContainer = styled.div`
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;
`;

export const VibrationContainer = styled.div`
  padding-top: 22px;
`;

export const CrusherAdjContainer = styled.div`
  padding-top: 54px;
  gap: 8px;
`;

export const CrusherSpeedContainer = styled.div`
  padding-top: 24px;
`;

export const CavityLevelContainer = styled.div`
  padding-top: 24px;
`;

export const CrusherModulesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 20px 0 20px;
  gap: 8px;
`;

export const CrusherRightParagraps = styled.div`
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`;

export const VibrationSensorContainer = styled.div`
  padding-top: 14px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;
`;

export const VibrationSensor2Container = styled.div`
  padding-top: 20px;
`;
export const CrusherAdjProx2Container = styled.div`
  padding-top: 54px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CountershaftTempContainer = styled.div`
  padding-top: 24px;
`;

export const MainLayout = styled.div`
  display: flex;
  width: 100%;
  gap: 0;
  position: relative;
`;

export const LeftSection = styled.div`
  flex: 1;
  padding-right: 20px;
  border-right: 1px solid ${({ theme }) => theme.color.ifmStatus.borderColor};
  min-width: 0;
`;

export const RightSection = styled.div`
  flex: 1;
  padding-left: 20px;
  min-width: 0;
`;

export const SectionContent = styled.div`
  display: flex;
  width: 100%;
  padding-top: 20px;

  @media (max-width: 1100px) {
    flex-direction: column;
    gap: 16px;
    justify-content: flex-start;
  };
`;
